

export default class Reviews {
    constructor(pageLoad) {
        // The Shopify Product Review app will load itself on document load,
        // we need to apply it manually when product section change
        if (pageLoad && window.hasOwnProperty('SPR')) {
            window.SPR.registerCallbacks();
            window.SPR.initRatingHandler();
            window.SPR.initDomEls();
            window.SPR.loadProducts();
            window.SPR.loadBadges();
        }
    }
}
